var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "layout document-form" },
      [
        _c("u-confirm", { ref: "confirm", attrs: { id: "delete-doctype" } }),
        _vm.loading
          ? _c("c-loader", {
              attrs: { label: "", active: _vm.loading, height: "500" },
            })
          : _c("div", [
              _c("div", { staticClass: "layout-header" }, [
                _c("div", { staticClass: "layout-title" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.id ? "Редактирование документа" : "Новый документ"
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "layout-header-actions" },
                  [
                    _vm.id
                      ? _c(
                          "div",
                          {
                            staticClass: "layout-header-action",
                            attrs: { id: `layout-header-action-${_vm.id}` },
                          },
                          [
                            _c("c-button-2", {
                              attrs: {
                                size: "small",
                                label: "Удалить",
                                icon: {
                                  icon: "trash",
                                  color: "secondary",
                                },
                                disabled: !_vm.savedData.canDelete,
                                responsive: true,
                              },
                              on: { click: _vm.deleteDocument },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.savedData.canDelete
                      ? _c(
                          "b-popover",
                          {
                            attrs: {
                              placement: "top",
                              triggers: "hover blur",
                              target: `layout-header-action-${_vm.id}`,
                            },
                          },
                          [
                            _c("error-feedback", {
                              staticClass: "m-0",
                              attrs: {
                                text: "В данный момент удаление невозможно, так как документ добавлен для сотрудников.",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "layout-header-action" },
                      [
                        _c("c-button-2", {
                          attrs: {
                            size: "small",
                            label: "К списку документов",
                            icon: {
                              icon: "back",
                              color: "blue",
                            },
                            responsive: true,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                name: "documents-list",
                              })
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "document-form__name" },
                  [
                    _c("c-input-2", {
                      style: {
                        "margin-bottom":
                          _vm.submitted && _vm.nameError ? "40px" : "",
                      },
                      attrs: {
                        "floating-label": "Название документа",
                        "required-mark": true,
                        required: _vm.submitted && _vm.nameError,
                        "required-message": _vm.submitted && _vm.nameError,
                        clearable: true,
                        "max-length": 255,
                      },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "document-form__type" },
                  [
                    _c("c-input-2", {
                      attrs: {
                        "floating-label": "Тип документа",
                        type: "select",
                        items: _vm.doctypesDictionary,
                        clearable: true,
                        searchable: true,
                      },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "document-form__statuses" },
                  [
                    _c("c-input-2", {
                      staticClass: "document-form__statuses__law-status",
                      attrs: {
                        "floating-label": "Правовой статус",
                        type: "select",
                        multiple: true,
                        items: _vm.statusesDictionary,
                        searchable: true,
                      },
                      model: {
                        value: _vm.form.statuses,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "statuses", $$v)
                        },
                        expression: "form.statuses",
                      },
                    }),
                    _c("c-input-2", {
                      staticClass: "document-form__statuses__gender",
                      attrs: {
                        label: "Пол",
                        type: "select",
                        placeholder: "Для всех",
                        items: _vm.genderTypes,
                        clearable: true,
                      },
                      model: {
                        value: _vm.form.gender,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "gender", $$v)
                        },
                        expression: "form.gender",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "document-form-issues" }, [
                  _c("h2", [_vm._v("Проблемы с документами")]),
                  _c(
                    "div",
                    { staticClass: "document-form-criticality" },
                    [
                      _c("c-input-2", {
                        staticClass: "document-form-criticality__value",
                        attrs: {
                          label: "Критичность документа",
                          type: "select",
                          items: _vm.criticalityTypes,
                        },
                        model: {
                          value: _vm.form.criticality,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "criticality", $$v)
                          },
                          expression: "form.criticality",
                        },
                      }),
                      _vm.form.criticality.value !== "optional"
                        ? _c("document-color", {
                            ref: "absentColor",
                            staticClass: "document-form-criticality__color",
                            attrs: {
                              label: "Цвет отсутствующего документа",
                              "default-color": "#FF0000",
                              validate: _vm.submitted,
                            },
                            model: {
                              value: _vm.form.absentColor,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "absentColor", $$v)
                              },
                              expression: "form.absentColor",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("div", [
                    _c(
                      "div",
                      { staticClass: "d-inline-block" },
                      [
                        _c("c-switcher", {
                          attrs: {
                            label: "Срок годности документа",
                            "label-full-name": "Срок годности документа",
                          },
                          model: {
                            value: _vm.form.hasExpireDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "hasExpireDate", $$v)
                            },
                            expression: "form.hasExpireDate",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm.form.hasExpireDate
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "document-form-expiration" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "document-form-expiration-indication",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "document-form-expiration-indication__field",
                                      style: {
                                        "margin-bottom":
                                          _vm.submitted && _vm.indicationError
                                            ? "30px"
                                            : "",
                                      },
                                    },
                                    [
                                      _c("c-input-2", {
                                        attrs: {
                                          label: "Индикация проблемы за",
                                          "required-mark": true,
                                          required:
                                            _vm.submitted &&
                                            _vm.indicationError,
                                          "required-message":
                                            _vm.submitted &&
                                            _vm.indicationError,
                                          mask: ["###"],
                                          clearable: true,
                                        },
                                        model: {
                                          value: _vm.form.indication,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "indication",
                                              $$v
                                            )
                                          },
                                          expression: "form.indication",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "document-form-expiration-indication__label",
                                        },
                                        [_vm._v("дней")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "document-form-expiration-indication__note",
                                    },
                                    [
                                      _vm._v(
                                        " Если нужно уведомлять о возникновении проблемы при вышедшем сроке, ставьте 0 дней "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c("document-color", {
                                ref: "expiredColor",
                                staticClass: "document-form-expiration__color",
                                attrs: {
                                  label: "Цвет истекшего срока годности",
                                  validate: _vm.submitted,
                                  "default-color": "#FF238D",
                                },
                                model: {
                                  value: _vm.form.expiredColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "expiredColor", $$v)
                                  },
                                  expression: "form.expiredColor",
                                },
                              }),
                              _c("document-color", {
                                ref: "expiringColor",
                                staticClass: "document-form-expiration__color",
                                attrs: {
                                  label: "Цвет истекающего срока годности",
                                  validate: _vm.submitted,
                                  "default-color": "#FFB800",
                                },
                                model: {
                                  value: _vm.form.expiringColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "expiringColor", $$v)
                                  },
                                  expression: "form.expiringColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "d-inline-block" },
                              [
                                _c("c-switcher", {
                                  attrs: {
                                    label: "Блокировка зарплаты",
                                    "label-full-name": "Блокировка зарплаты",
                                  },
                                  model: {
                                    value: _vm.form.salaryLock,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "salaryLock", $$v)
                                    },
                                    expression: "form.salaryLock",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm.form.salaryLock
                            ? _c("c-input-2", {
                                staticClass: "document-form__salary-conditions",
                                attrs: {
                                  label: "Условие блокировки",
                                  "required-mark": true,
                                  required:
                                    _vm.submitted && _vm.salaryLockError,
                                  "required-message":
                                    _vm.submitted && _vm.salaryLockError,
                                  placeholder: "Все",
                                  type: "select",
                                  multiple: true,
                                  items: _vm.blockingConditionsDictionary,
                                },
                                model: {
                                  value: _vm.form.blockingConditions,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "blockingConditions",
                                      $$v
                                    )
                                  },
                                  expression: "form.blockingConditions",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _c(
                  "section",
                  { staticClass: "document-form-conditions" },
                  [
                    _c(
                      "header",
                      { staticClass: "document-form-conditions__header" },
                      [
                        _c("toggle-button", {
                          model: {
                            value: _vm.conditionsIsOpen,
                            callback: function ($$v) {
                              _vm.conditionsIsOpen = $$v
                            },
                            expression: "conditionsIsOpen",
                          },
                        }),
                        _c("h2", [
                          _vm._v(" Условия применения "),
                          _c("span", { staticClass: "count" }, [
                            _vm._v(
                              _vm._s(_vm.filledConditions.length || "Для всех")
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "slide-up-down",
                      {
                        staticClass: "document-form-conditions__items",
                        attrs: { active: _vm.conditionsIsOpen, duration: 400 },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "document-conditions" },
                          _vm._l(_vm.form.conditions, function (condition, i) {
                            return _c("document-condition", {
                              key: i,
                              staticClass: "document-conditions__item",
                              attrs: {
                                condition: condition,
                                validate: _vm.submitted,
                              },
                              on: {
                                remove: function ($event) {
                                  return _vm.removeCondition(condition)
                                },
                              },
                            })
                          }),
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "document-form-conditions__add" },
                          [
                            _c("c-button", {
                              attrs: {
                                disabled: _vm.hasEmptyConditions,
                                label: "Добавить условие",
                                icon: {
                                  icon: "plus",
                                  color: "blue",
                                },
                              },
                              on: { click: _vm.addCondition },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "section",
                  { staticClass: "document-form-notifications" },
                  [
                    _c(
                      "header",
                      { staticClass: "document-form-notifications__header" },
                      [
                        _c("toggle-button", {
                          model: {
                            value: _vm.notificationsIsOpen,
                            callback: function ($$v) {
                              _vm.notificationsIsOpen = $$v
                            },
                            expression: "notificationsIsOpen",
                          },
                        }),
                        _c("h2", [
                          _vm._v(" Уведомления "),
                          _c("span", { staticClass: "count" }, [
                            _vm._v(
                              _vm._s(_vm.filledNotifications.length || "Нет")
                            ),
                          ]),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "slide-up-down",
                      {
                        staticClass: "document-form-notifications__items",
                        attrs: {
                          active: _vm.notificationsIsOpen,
                          duration: 400,
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "document-notifications" },
                          _vm._l(
                            _vm.form.notifications,
                            function (notification, i) {
                              return _c("document-notification", {
                                key: i,
                                staticClass: "document-notifications__item",
                                attrs: {
                                  validate: _vm.submitted,
                                  notification: notification,
                                },
                                on: {
                                  remove: function ($event) {
                                    return _vm.removeNotification(notification)
                                  },
                                },
                              })
                            }
                          ),
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "document-form-conditions__add" },
                          [
                            _c("c-button", {
                              attrs: {
                                disabled: _vm.hasEmptyNotifications,
                                label: "Добавить уведомление",
                                icon: {
                                  icon: "plus",
                                  color: "blue",
                                },
                              },
                              on: { click: _vm.addNotification },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "document-form__actions" },
                [
                  _c("c-button-2", {
                    staticClass: "document-form__reset",
                    attrs: { size: "large", label: "Отменить" },
                    on: { click: _vm.reset },
                  }),
                  _c("c-button-2", {
                    staticClass: "document-form__save",
                    attrs: {
                      label: "Сохранить",
                      color: "primary",
                      size: "large",
                      disabled: _vm.pending,
                    },
                    on: { click: _vm.submit },
                  }),
                ],
                1
              ),
            ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }